import React,{useEffect, useState} from "react";
import { ChevronRight } from "lucide-react";
import './css/Subjects.css'
import axios from "./../axios";
import { useNavigate } from "react-router-dom";
const Subjects = ()=>{
   const [subjects, setSubjects] = useState([
  { name: 'loading...', alert: false },
   
]);
const [is_updated,setIsUpdated]=useState(0);
  useEffect(() => {
  const fetchData = async () => {
    try {
      const token = localStorage.getItem("student_token"); // or pass from props/context

      const response = await axios.get('student/subjects', {
        headers: {
          Authorization: `Bearer ${token}`, // ✅ clean header
        },
      });
 
      console.log(response.data);
      setSubjects(response.data);
     } catch (error) {
      console.error('Error fetching profile:', error);
    }
  };

  fetchData();
}, []);
useEffect(
()=>{
const sortedSubjects = subjects.sort((a, b) => b.alert - a.alert);
setSubjects([...sortedSubjects]);

},[]
);
const navigate = useNavigate();

  return(  <>
  
  <div className="subject-title-area">
    <div className="title-subject">
    Assignements
    </div>
    <div className="viewAll-subjects" onClick={()=>navigate('/student/homework')}>
        View All <ChevronRight/>
    </div>
  </div>
    <div className="subject-containor" >
        {subjects.map((subject, index) => (
  <div className="subject" onClick={() => navigate('/student/homework', {
  state: { autoopen: subject.name }
})}
 key={index}>
    
    {subject.name}
    {subject.alert ? (
    <div className="subject-dot"></div>

    ):null}
  
  </div>
))}
       
    </div>
    </>
    );
};

export default Subjects;